import axios from "axios";

const publicUrl = process.env.PUBLIC_URL || '';

export const getCurrentStep = async () => {
    const {data} = await axios.get(publicUrl + '/step');
    return data.step;
};

export const submitStep = async (stepName, stepResponse) => {
    const {data} = await axios.post(publicUrl + '/step', {stepName, ...stepResponse});
    return data.step;
};

export const submitExercise = async (exerciseLevel, exerciseResponse) => {
    return axios.post(publicUrl + '/exercise', {exerciseLevel, ...exerciseResponse});
};

export const getSubmittedExercises = async () => {
    return axios.get(publicUrl + '/exercises');
};
